// extracted by mini-css-extract-plugin
module.exports = {"primaryFacet":"PrimaryFacet_primaryFacet__hZaM9"};